export default "__VITE_ASSET__CEDFC4Gm__"